module.exports = __webpack_public_path__ + "img/valid.e1b5a0a3.svg";